import React, { useEffect, useState } from 'react';
import Loading from 'react-loading';
import Pagination from './Pagination'; // مسیر را به درستی تنظیم کنید
import '../../../main.css';

const ProductsList = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;

  useEffect(() => {
    const fetchProducts = async () => {
      try {                           
        const response = await fetch('https://api2.raynogroup.com/api/products?company_id=4&inventory=all');
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setProducts(data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  if (loading) return <Loading type="bars" color="#000" height={50} width={50} />;
  if (error) return <div>Error: {error}</div>;

  const offset = currentPage * itemsPerPage;
  const currentItems = products.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(products.length / itemsPerPage);

  return (
    <div className="card">
      <div className="card-body">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>کد نرم‌افزار</th>
              <th>شرح نرم افزار/افزونه</th>
              <th>قیمت</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((product, index) => (
              <tr key={index} className="hover-shadow notification-item">
                <td>{product.product_barcode}</td>
                <td>{product.name}</td>
                <td>{product.price}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <Pagination pageCount={pageCount} onPageChange={handlePageClick} />
      </div>
    </div>
  );
};

export default ProductsList;
